import { createAction, props } from '@ngrx/store';

export const retrieve = createAction('[MGM Config] Retrieve', props<{ id: string }>());
export const retrieveSuccess = createAction('[MGM Config] Retrieve Success', props<{ config: any }>());
export const retrieveFailure = createAction('[MGM Config] Retrieve Failure', props<{ error: string }>());
